/* eslint-disable */
import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import ProtectedRoute from 'routes/ProtectRoute';
import {
    ConditionalRenderViewCustomerPage,
    ConditionalRenderCreateCustomerPage,
    ConditionalRenderViewBeneficiaryPage,
    ConditionalRenderCreateBeneficiaryPage,
    ConditionalRenderDmtTransferPage
} from 'views/ConditionalRender(New DMT)';
const ListAllBeneficiaryPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtFino/ListAllBeneficiary')));
const ListMoneyTransferPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtFino/ListMoneyTransfer')));
const DmtReceiptPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtFino/ReceiptPage')));
const DmtReportPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtFino/DmtReport')));
const ReportRecieptPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtFino/DmtReceipt')));
const AuthCheckDmtIserveu = Loadable(lazy(() => import('views/AuthCheckDmtIServeu')));
const Dmt2CreateCustomerPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DMTIserveu/CreateCustomer')));
const Dmt2ViewBeneFiciary = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DMTIserveu/DmtTransfer')));
const Dmt2AddBeneFiciaryPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DMTIserveu/CheckBeneficiaryStatus')));
const Dmt2TransferPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DMTIserveu/TransferPage')));
const AuthDmt3CustomerList = Loadable(lazy(() => import('views/AuthCheckDmtAirtel')));
const Dmt3ViewBeneficiary = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtAirtel/BeneficiaryList')));
const Dmt3CreateCustomerPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtAirtel/CreateCustomer')));
const Dmt3CreateBeneficiaryPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtAirtel/CreateBeneficiary')));
const Dmt3TransferPage = Loadable(lazy(() => import('views/bankingServices/money transfer(DMT)/DmtAirtel/TransferPage')));

export const dmtUpdatedRoutes = [
    {
        path: 'moneyTransfer1',
        children: [
            {
                path: 'viewCustomers',
                element: <ProtectedRoute element={<ConditionalRenderViewCustomerPage />} />
                // element: <ProtectedRoute element={<DmtTableIserveu />} />
            },
            // {
            //     path: 'iserveuDmtTable',
            //     element: <ProtectedRoute element={<DmtTableIserveu />} />
            // },
            {
                path: 'moneyTransfer',
                element: <ProtectedRoute element={<ConditionalRenderDmtTransferPage />} />
            },
            {
                path: 'viewBeneficiary',
                element: <ProtectedRoute element={<ConditionalRenderViewBeneficiaryPage />} />
            },
            {
                path: 'createBeneficiary',
                element: <ProtectedRoute element={<ConditionalRenderCreateBeneficiaryPage />} />
            },
            {
                path: 'listAllBeneficiary',
                element: <ProtectedRoute element={<ListAllBeneficiaryPage />} />
            },

            {
                path: 'listMoneyTransfer',
                element: <ProtectedRoute element={<ListMoneyTransferPage />} />
            },
            {
                path: 'createCustomer',
                element: <ProtectedRoute element={<ConditionalRenderCreateCustomerPage />} />
            },
            {
                path: 'transferReceipt',
                element: <ProtectedRoute element={<DmtReceiptPage />} />
            },
            {
                path: 'dmtReport',
                element: <ProtectedRoute element={<DmtReportPage />} />
            },
            {
                path: 'dmtReciept',
                element: <ProtectedRoute element={<ReportRecieptPage />} />
            }
        ]
    },
    {
        path: 'moneyTransfer2',
        children: [
            {
                path: 'viewCustomers',
                element: <ProtectedRoute element={<AuthCheckDmtIserveu />} />
            },
            {
                path: 'createCustomer',
                element: <ProtectedRoute element={<Dmt2CreateCustomerPage />} />
            },
            {
                path: 'viewBeneficiary',
                element: <ProtectedRoute element={<Dmt2ViewBeneFiciary />} />
            },
            {
                path: 'createBeneficiary',
                element: <ProtectedRoute element={<Dmt2AddBeneFiciaryPage />} />
            },
            {
                path: 'moneyTransfer',
                element: <ProtectedRoute element={<Dmt2TransferPage />} />
            }
        ]
    },
    {
        path: 'moneyTransfer3',
        children: [
            {
                path: 'viewCustomers',
                element: <ProtectedRoute element={<AuthDmt3CustomerList />} />
            },
            {
                path: 'viewBeneficiary',
                element: <ProtectedRoute element={<Dmt3ViewBeneficiary />} />
            },
            {
                path: 'createCustomer',
                element: <ProtectedRoute element={<Dmt3CreateCustomerPage />} />
            },
            {
                path: 'createBeneficiary',
                element: <ProtectedRoute element={<Dmt3CreateBeneficiaryPage />} />
            },
            {
                path: 'transfer',
                element: <ProtectedRoute element={<Dmt3TransferPage />} />
            }
        ]
    }
];